import { usePostActivityLog } from 'hook/usePostActivityLog';

const ActivityLog = ({ children, module, isAuth = false }) => {
    usePostActivityLog(module, isAuth);
    return children;
};

export default ActivityLog;
